// Mock data for Mesh Lighting Ltd website with actual brand images

export const meshLightingInfo = {
  name: "Mesh Lighting Ltd",
  tagline: "Architectural Lighting Sales Agency",
  description: "Mesh Lighting Ltd is a specialist architectural lighting sales agency representing leading European and American lighting manufacturers in the UK market. We work closely with lighting designers, architects, and contractors to deliver exceptional lighting solutions for prestigious projects.",
  logo: "https://customer-assets.emergentagent.com/job_light-agency-mesh/artifacts/gzu1oohk_MESH%20WORKABLE.jpg",
  contact: {
    email: "info@meshlighting.co.uk",
    phone: "+44 (0) 20 7123 4567",
    address: "London, United Kingdom"
  },
  social: {
    linkedin: "https://linkedin.com/company/mesh-lighting",
    instagram: "https://instagram.com/meshlighting"
  }
};

export const brands = [
  {
    id: "technilum",
    name: "Technilum",
    logo: "https://www.technilum.com/app/themes/technilum/img/logo.svg",
    website: "https://www.technilum.com",
    heroImage: "https://www.technilum.com/app/uploads/2024/02/L-Houston-Lynn-Wyatt-Square-TZ.jpg",
    country: "France",
    specialty: "Outdoor Urban Lighting",
    about: "For 50 years, Technilum has been designing and manufacturing urban lighting furniture, equipping public areas and private developments worldwide with both standard products and highly customizable smart lighting solutions. As a French manufacturer of outdoor lighting products, they supply high-performance aluminum light poles, bollards and wall-mounts for all kinds of landscape, architectural or functional lighting projects. Sustainable development drives their company strategy, exclusively using aluminum - a 100% recyclable material with unequaled durability.",
    features: [
      "50+ years of expertise",
      "Made in France",
      "100% recyclable aluminum",
      "Custom solutions available",
      "Smart city integration"
    ],
    news: [
      {
        id: 1,
        title: "Technilum in Corsica - Calvi Project",
        date: "February 2025",
        excerpt: "This project showcases unique lighting solutions designed by Technilum, featuring the Creille GM column adorned with a timeless pattern in Corsica's Christophe Colomb square.",
        image: "https://www.technilum.com/app/uploads/2025/02/L-Calvi-Place-des-commercants.jpg"
      },
      {
        id: 2,
        title: "New Lighting for Basanavičius Promenade",
        date: "May 2025",
        excerpt: "New lighting installation for the famous promenade in Palanga, Lithuania featuring custom Technilum solutions.",
        image: "https://www.technilum.com/app/uploads/2025/05/Palanga-usine.jpg"
      },
      {
        id: 3,
        title: "Olympic Aquatic Center, Saint-Denis",
        date: "2024",
        excerpt: "Technilum lighting columns illuminate the prestigious Olympic Aquatic Center for Paris 2024.",
        image: "https://www.technilum.com/app/uploads/2024/09/L-Saint-Denis-CAO.jpg"
      }
    ],
    bestOf: [
      {
        id: 1,
        name: "Structure K",
        description: "Iconic lighting column for prestigious urban projects",
        image: "https://www.technilum.com/app/uploads/2024/11/L-Nimes-Halles-des-sports.jpg"
      },
      {
        id: 2,
        name: "Aubin Range",
        description: "Modular, efficient and timeless urban lighting",
        image: "https://www.technilum.com/app/uploads/2025/02/Focus-Aubin-gamme.png"
      },
      {
        id: 3,
        name: "Niagara Bollards",
        description: "Sleek design with high-performance LED optics",
        image: "https://www.technilum.com/app/uploads/2024/10/L-Colombiers-jardins-mairie.jpg"
      },
      {
        id: 4,
        name: "Smart-in-Site",
        description: "Connected smart lighting for smart cities",
        image: "https://www.technilum.com/app/uploads/2017/04/Technilum_transparent_GIF_V4.gif"
      }
    ],
    projects: [
      {
        id: 1,
        name: "Lynn Wyatt Square for the Performing Arts",
        location: "Houston, USA",
        year: "2023",
        image: "https://www.technilum.com/app/uploads/2024/02/L-Houston-Lynn-Wyatt-Square-TZ.jpg"
      },
      {
        id: 2,
        name: "Western Campus University",
        location: "Glasgow, Scotland",
        year: "2024",
        image: "https://www.technilum.com/app/uploads/2024/10/L-Glasgow-University-of-Glasgow-Western-Campus.jpg"
      },
      {
        id: 3,
        name: "Horseshoe Bay Pathway",
        location: "West Vancouver, Canada",
        year: "2023",
        image: "https://www.technilum.com/app/uploads/2025/11/L-West-Vancouver-Horseshoe-Bay-1.jpg"
      },
      {
        id: 4,
        name: "Mandarin Oriental Hotel",
        location: "Muscat, Oman",
        year: "2024",
        image: "https://www.technilum.com/app/uploads/2025/05/L-Oman-Muscat-Mandarin-Oriental-Hotel.jpg"
      }
    ]
  },
  {
    id: "lucelight",
    name: "Luce&Light",
    logo: "https://www.lucelight.it/img/logo.svg",
    website: "https://www.lucelight.it",
    heroImage: "https://www.lucelight.it/file/jpeg/900x506/progetto-201234.jpg",
    country: "Italy",
    specialty: "Architectural LED Lighting",
    about: "L&L Luce&Light is an LED-native company based in Dueville, in the heart of Italy's Veneto region, bringing the excellence of Made in Italy to the world through high-quality architectural lighting solutions. Their mission is to sculpt space – whether historic facades, urban landscapes or residential green spaces – with lighting that combines precision optics and minimalist design. They believe in light that doesn't just illuminate but also integrates into and respects its surroundings to create comfortable, appealing ambiences.",
    features: [
      "Made in Italy",
      "LED-native technology",
      "Precision optics",
      "Indoor, outdoor & underwater",
      "Custom solutions"
    ],
    news: [
      {
        id: 1,
        title: "Parco Storico Bricherasio",
        date: "2025",
        excerpt: "Lighting design for the redevelopment of a historical park in Fubine Monferrato, Italy.",
        image: "https://www.lucelight.it/file/jpeg/900x506/progetto-201234.jpg"
      },
      {
        id: 2,
        title: "New Teak Wood Bollards",
        date: "November 2025",
        excerpt: "New FSC-certified teak body for Intono B, Olo, Plin and Plin Round bollards.",
        image: "https://www.lucelight.it/file/mfamfotoel-200967.jpg"
      },
      {
        id: 3,
        title: "Olo Blvd Launch",
        date: "December 2025",
        excerpt: "Pole-mounted solution designed for cycle paths, footpaths, car parks and green spaces.",
        image: "https://www.lucelight.it/file/jpeg/767x575/fotonot-201269.jpg"
      }
    ],
    bestOf: [
      {
        id: 1,
        name: "Ginko Series",
        description: "Versatile projectors for landscape and architectural lighting",
        image: "https://www.lucelight.it/media/prodotti/foto/jpeg/450x450/ginko_3.0_still.jpg"
      },
      {
        id: 2,
        name: "Plin Bollards",
        description: "Minimalist bollards for pathways and gardens",
        image: "https://www.lucelight.it/media/prodotti/foto/jpeg/450x450/plin_1.2_still.jpg"
      },
      {
        id: 3,
        name: "Corso Linear",
        description: "Linear profiles for architectural contours",
        image: "https://www.lucelight.it/media/prodotti/foto/jpeg/450x450/corso_3.0_still.jpg"
      },
      {
        id: 4,
        name: "Oliver Collection",
        description: "High-performance reading lamps and projectors",
        image: "https://www.lucelight.it/file/mfamfotoel-193411.jpg"
      }
    ],
    projects: [
      {
        id: 1,
        name: "Lim Tower III",
        location: "Ho Chi Minh, Vietnam",
        year: "2024",
        image: "https://www.lucelight.it/file/progetto-200413.jpg"
      },
      {
        id: 2,
        name: "Parco Storico Bricherasio",
        location: "Fubine Monferrato, Italy",
        year: "2025",
        image: "https://www.lucelight.it/file/jpeg/900x506/progetto-201234.jpg"
      },
      {
        id: 3,
        name: "Palazzo Schifanoia Gardens",
        location: "Ferrara, Italy",
        year: "2024",
        image: "https://www.lucelight.it/file/progetto-200601.jpg"
      },
      {
        id: 4,
        name: "Munch Museum",
        location: "Oslo, Norway",
        year: "2023",
        image: "https://www.lucelight.it/file/progetto-148345.jpg"
      }
    ]
  },
  {
    id: "lucifer",
    name: "Lucifer Lighting",
    logo: "https://www.luciferlighting.com/getattachment/19e5c6a2-57e9-43bf-8e76-8e6b7ca8d6b2/logo.svg",
    website: "https://www.luciferlighting.com",
    heroImage: "https://www.luciferlighting.com/getattachment/487fa26e-4c79-4885-aeb5-c8ffb5e3ddf4/23109_press_cartier_soho_rd2_11-14-23_008-1.jpg",
    country: "USA",
    specialty: "Precision Interior Lighting",
    about: "Lucifer Lighting represents one family's forty-five year love affair with light. They light the world's most recognizable hotels, museums, and other thoughtfully designed environments. Known for innovation and craftsmanship, Lucifer Lighting creates precision lighting fixtures that let designers do more with light. Their finely tuned features and attention to detail have made them a go-to choice for architects and lighting designers seeking the highest quality interior lighting solutions.",
    features: [
      "45+ years of expertise",
      "Made in USA",
      "Precision optics",
      "Recessed & surface mount",
      "Track & pendant systems"
    ],
    news: [
      {
        id: 1,
        title: "Stellaris Launch",
        date: "August 2025",
        excerpt: "No Limits. Just Light. Introducing the new Stellaris surface mount fixture.",
        image: "https://www.luciferlighting.com/getattachment/f440471e-a9b4-4726-9467-6d42ca33b122/Stellaris_White.png"
      },
      {
        id: 2,
        title: "The Frick Collection Project",
        date: "2024",
        excerpt: "Premium lighting installation at the prestigious Frick Collection museum in New York.",
        image: "https://www.luciferlighting.com/getattachment/ce346815-e1f3-4de9-9fc3-b021edf08cac/TFC_Venezia_IC07-EDIT-(1).jpg"
      },
      {
        id: 3,
        title: "Fraxion3 Innovation",
        date: "2025",
        excerpt: "Variety + Elegance in a 3-inch aperture recessed fixture.",
        image: "https://www.luciferlighting.com/getattachment/219ab903-0adc-4fe1-a649-92c6c759c42f/Fraxion3_White.png"
      }
    ],
    bestOf: [
      {
        id: 1,
        name: "Fraxion Series",
        description: "Premium recessed downlights in multiple apertures",
        image: "https://www.luciferlighting.com/getattachment/219ab903-0adc-4fe1-a649-92c6c759c42f/Fraxion3_White.png"
      },
      {
        id: 2,
        name: "Cylinder Collection",
        description: "Surface mount cylinders in 5 sizes",
        image: "https://www.luciferlighting.com/getattachment/d314e051-665a-4146-a59e-6ded42c80a3e/Cylinder_Grey-(1).png"
      },
      {
        id: 3,
        name: "Monopoint",
        description: "Designed to be directed - adjustable accent lighting",
        image: "https://www.luciferlighting.com/getattachment/fbf49134-1645-426f-9561-09c06191f28f/Monopoint_White-(1).png"
      },
      {
        id: 4,
        name: "STELLR",
        description: "Dual-source ceiling mount or pendant",
        image: "https://www.luciferlighting.com/getattachment/60192a7a-6d8c-4e27-815d-f82777fabd0f/STELLR_Grey-(1).png"
      }
    ],
    projects: [
      {
        id: 1,
        name: "The Frick Collection",
        location: "New York, USA",
        year: "2024",
        image: "https://www.luciferlighting.com/getattachment/ce346815-e1f3-4de9-9fc3-b021edf08cac/TFC_Venezia_IC07-EDIT-(1).jpg"
      },
      {
        id: 2,
        name: "Cartier SoHo",
        location: "New York, USA",
        year: "2023",
        image: "https://www.luciferlighting.com/getattachment/487fa26e-4c79-4885-aeb5-c8ffb5e3ddf4/23109_press_cartier_soho_rd2_11-14-23_008-1.jpg"
      },
      {
        id: 3,
        name: "Apple Upper East Side",
        location: "New York, USA",
        year: "2024",
        image: "https://www.luciferlighting.com/getattachment/16b63f26-2cac-44ee-95e0-9ace149eeb2a/940-Madison-Ave-Apple-Store-Downlights.jpg"
      },
      {
        id: 4,
        name: "Rosewood Miramar Beach Hotel",
        location: "Montecito, California",
        year: "2023",
        image: "https://www.luciferlighting.com/getattachment/73769082-231d-4843-85ce-a7ca378f1e82/RWSBM_LivingRoomDetail.jpg"
      }
    ]
  },
  {
    id: "atea",
    name: "ATEA",
    logo: "https://www.atea.fr/images/logo.svg",
    website: "https://www.atea.fr",
    heroImage: "https://images.unsplash.com/photo-1689956358666-b6ff6c9e3ebc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxmYWNhZGUlMjBsaWdodGluZ3xlbnwwfHx8fDE3Njk3NzUzODN8MA&ixlib=rb-4.1.0&q=85",
    country: "France",
    specialty: "Custom Architectural Lighting",
    about: "ATEA is a French specialist in architectural lighting, where light is an integral part of architecture. Their expertise allows them to recreate structural axes and define the ambiance of spaces. With the significant technological developments in lighting sources and fixtures over recent years - in terms of performance and economy - ATEA integrates these new tools daily, with the project of putting aesthetic research and technology at the service of light. Notable projects include La Mamounia, Château de Versailles, Fondation LVMH, and The Peninsula.",
    features: [
      "Made in France",
      "Bespoke solutions",
      "Heritage projects",
      "Luxury hospitality",
      "Museum lighting"
    ],
    news: [
      {
        id: 1,
        title: "Château de Versailles Project",
        date: "2025",
        excerpt: "Prestigious lighting installation at the historic Palace of Versailles.",
        image: "https://images.unsplash.com/photo-1689956358666-b6ff6c9e3ebc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxmYWNhZGUlMjBsaWdodGluZ3xlbnwwfHx8fDE3Njk3NzUzODN8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        title: "La Mamounia Renovation",
        date: "2024",
        excerpt: "Custom lighting solutions for the legendary Moroccan palace hotel.",
        image: "https://images.unsplash.com/photo-1760385737072-3b59d152c352?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpZ2h0aW5nfGVufDB8fHx8MTc2OTc3NTM5MXww&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        title: "Fondation LVMH",
        date: "2024",
        excerpt: "Architectural lighting for the iconic Frank Gehry-designed museum.",
        image: "https://images.unsplash.com/photo-1571440727633-ca6b05da2008?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzY5Nzc1MzcxfDA&ixlib=rb-4.1.0&q=85"
      }
    ],
    bestOf: [
      {
        id: 1,
        name: "Heritage Collection",
        description: "Bespoke fixtures for historic buildings",
        image: "https://images.unsplash.com/photo-1689956358666-b6ff6c9e3ebc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxmYWNhZGUlMjBsaWdodGluZ3xlbnwwfHx8fDE3Njk3NzUzODN8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        name: "Hospitality Series",
        description: "Luxury lighting for world-class hotels",
        image: "https://images.unsplash.com/photo-1760385737072-3b59d152c352?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpZ2h0aW5nfGVufDB8fHx8MTc2OTc3NTM5MXww&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        name: "Museum Grade",
        description: "Precision lighting for art and exhibitions",
        image: "https://images.unsplash.com/photo-1571440727633-ca6b05da2008?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzY5Nzc1MzcxfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        name: "Architectural Custom",
        description: "Tailored solutions for unique spaces",
        image: "https://images.unsplash.com/photo-1762144637568-a87f3a454d18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpZ2h0aW5nfGVufDB8fHx8MTc2OTc3NTM5MXww&ixlib=rb-4.1.0&q=85"
      }
    ],
    projects: [
      {
        id: 1,
        name: "La Mamounia",
        location: "Marrakech, Morocco",
        year: "2024",
        image: "https://images.unsplash.com/photo-1760385737072-3b59d152c352?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpZ2h0aW5nfGVufDB8fHx8MTc2OTc3NTM5MXww&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 2,
        name: "Château de Versailles",
        location: "Versailles, France",
        year: "2025",
        image: "https://images.unsplash.com/photo-1689956358666-b6ff6c9e3ebc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxmYWNhZGUlMjBsaWdodGluZ3xlbnwwfHx8fDE3Njk3NzUzODN8MA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 3,
        name: "Fondation Louis Vuitton",
        location: "Paris, France",
        year: "2024",
        image: "https://images.unsplash.com/photo-1571440727633-ca6b05da2008?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzY5Nzc1MzcxfDA&ixlib=rb-4.1.0&q=85"
      },
      {
        id: 4,
        name: "The Peninsula",
        location: "Paris, France",
        year: "2023",
        image: "https://images.unsplash.com/photo-1762144637568-a87f3a454d18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGxpZ2h0aW5nfGVufDB8fHx8MTc2OTc3NTM5MXww&ixlib=rb-4.1.0&q=85"
      }
    ]
  }
];

export const meshNews = [
  {
    id: 1,
    title: "Join Us in London - February Event",
    date: "January 27, 2026",
    excerpt: "Thursday 19 February at 6pm - Join us in London for an informal evening on delivering architectural lighting excellence.",
    image: "https://www.technilum.com/app/uploads/2024/02/L-Houston-Lynn-Wyatt-Square-TZ.jpg",
    category: "Events"
  },
  {
    id: 2,
    title: "10 Years of Neon - Lighting Art Installation",
    date: "May 1, 2025",
    excerpt: "We're proud to say this was possibly the best lighting art installation we've ever been part of!",
    image: "https://www.lucelight.it/file/progetto-200852.jpg",
    category: "Projects"
  },
  {
    id: 3,
    title: "Light24 Exhibition Success",
    date: "December 10, 2024",
    excerpt: "Is it just us or does it get better each year? We had a lovely time at Light24.",
    image: "https://www.luciferlighting.com/getattachment/ce346815-e1f3-4de9-9fc3-b021edf08cac/TFC_Venezia_IC07-EDIT-(1).jpg",
    category: "Events"
  },
  {
    id: 4,
    title: "New Mesh Brands for 2025",
    date: "December 16, 2024",
    excerpt: "Introducing Modo Luce - Our first decorative brand making interior, exterior and acoustic luminaires.",
    image: "https://www.lucelight.it/file/mfamfotoel-200967.jpg",
    category: "Announcements"
  },
  {
    id: 5,
    title: "Technilum Structure K at Battersea",
    date: "June 15, 2023",
    excerpt: "Iconic Technilum Structure K columns installed at the prestigious Battersea development in London.",
    image: "https://www.technilum.com/app/uploads/2024/11/L-Nimes-Halles-des-sports.jpg",
    category: "Projects"
  },
  {
    id: 6,
    title: "Luce&Light at Munch Museum",
    date: "May 1, 2025",
    excerpt: "Our partners at Luce&Light completed a stunning installation at the Munch Museum in Oslo.",
    image: "https://www.lucelight.it/file/progetto-148345.jpg",
    category: "Projects"
  }
];
